export const formatWithCommas = (num: number) => {
  const [integerPart, decimalPart] = num.toString().split(".");
  const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimalPart ? `${withCommas}.${decimalPart}` : withCommas;
};

export const formatNumber = (num: number) => {
  if (num <= 100) {
    return num;
  }

  const roundedUp = Math.ceil(num * 100) / 100;
  return roundedUp.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
